import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { CalloutBlock } from '../../../types/backend';
import { calloutSeverity } from './blockFormat';

interface Props {
  block: CalloutBlock;
}

const CalloutBlockView: React.FC<Props> = ({ block }) => {
  const severity = calloutSeverity(block.variant);
  const mainColor = `${severity}.main`;

  return (
    <Box
      role="note"
      sx={{
        my: 1.5,
        px: 2,
        py: 1.5,
        borderRadius: 2,
        borderLeft: '4px solid',
        borderColor: mainColor,
        // Subtle severity-tinted surface derived from the theme — no raw hex.
        bgcolor: (theme) => alpha(theme.palette[severity].main, 0.1),
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      {block.title && (
        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: mainColor }}>
          {block.title}
        </Typography>
      )}
      <Typography variant="body2" sx={{ color: 'text.primary', lineHeight: 1.6 }}>
        {block.text}
      </Typography>
    </Box>
  );
};

export default CalloutBlockView;
